import images from "./images";

const eventMenu = {
    gourmetCanapésCategory: [
        {
            id: 1,
            image: images.canapés1,
            title: "Salmon Blini",
            content: "Delicate smoked salmon on fluffy mini pancakes with cream cheese and herbs.",
            details: {
                price: "12",
                rating: "4.7/5 (based on 215 reviews)",
                portionSize: "120g",
                preparationTime: "12 mins",
                allergens: "Fish, Dairy, Gluten",
                servingTemperature: "Cold",
                dietaryInfo: "Pescatarian",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Sparkling Wine"
            },
            paragraphs: [
                "Enjoy our refined Salmon Blini—thin, fluffy pancakes topped with luscious cream cheese and silky smoked salmon, garnished with herbs for an elegant bite.",
                "This dish is a timeless appetizer, combining the richness of smoked salmon with the tangy creaminess of cheese and a light, airy blini base. Perfect for parties, events, or gourmet starters."
            ],
            ingredients: [
                "Smoked Salmon",
                "Blini (Mini Pancakes)",
                "Cream Cheese",
                "Lemon Juice",
                "Fresh Dill",
                "Chives",
                "Salt",
                "Black Pepper",
                "Olive Oil"
            ],
            nutritions: [
                { label: "Calories", value: "220 kcal" },
                { label: "Protein", value: "12g" },
                { label: "Carbohydrates", value: "15g" },
                { label: "Fat", value: "14g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "480mg" },
                { label: "Cholesterol", value: "35mg" }
            ]
        },
        {
            id: 2,
            image: images.canapés2,
            title: "Truffle Tart",
            content: "Savory tart filled with creamy truffle-infused mushrooms and herbs.",
            details: {
                price: "10",
                rating: "4.6/5 (based on 198 reviews)",
                portionSize: "130g",
                preparationTime: "15 mins",
                allergens: "Dairy, Gluten, Eggs",
                servingTemperature: "Warm",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "White Wine"
            },
            paragraphs: [
                "Delight in the earthy elegance of our Truffle Tart—crafted with a flaky pastry crust and a rich, velvety filling of truffle cream and sautéed mushrooms.",
                "Each bite offers a luxurious blend of wild mushrooms, herbs, and a hint of truffle oil baked into a golden tart shell. It’s the perfect appetizer or light gourmet snack."
            ],
            ingredients: [
                "Pastry Shell",
                "Mushrooms",
                "Truffle Oil",
                "Heavy Cream",
                "Parmesan Cheese",
                "Eggs",
                "Thyme",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "250 kcal" },
                { label: "Protein", value: "9g" },
                { label: "Carbohydrates", value: "18g" },
                { label: "Fat", value: "17g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "390mg" },
                { label: "Cholesterol", value: "50mg" }
            ]
        },
        {
            id: 3,
            image: images.canapés3,
            title: "Cheese Crostini",
            content: "Toasted baguette slices topped with creamy cheese and herbs.",
            details: {
                price: "8",
                rating: "4.4/5 (based on 162 reviews)",
                portionSize: "120g",
                preparationTime: "12 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Warm",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Sparkling Wine"
            },
            paragraphs: [
                "Enjoy our Cheese Crostini—crunchy slices of toasted baguette layered with rich, melted cheese and a touch of herbs for a flavorful starter.",
                "Perfect for entertaining or as a refined snack, these crostinis combine the textures of crispy bread and creamy cheese with aromatic toppings."
            ],
            ingredients: [
                "Baguette",
                "Cream Cheese",
                "Mozzarella",
                "Garlic",
                "Olive Oil",
                "Parsley",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "230 kcal" },
                { label: "Protein", value: "8g" },
                { label: "Carbohydrates", value: "20g" },
                { label: "Fat", value: "14g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "310mg" },
                { label: "Cholesterol", value: "35mg" }
            ]
        },
        {
            id: 4,
            image: images.canapés4,
            title: "Caprese Skewer",
            content: "Fresh mozzarella, cherry tomatoes, and basil on a skewer.",
            details: {
                price: "6",
                rating: "4.6/5 (based on 140 reviews)",
                portionSize: "100g",
                preparationTime: "8 mins",
                allergens: "Dairy",
                servingTemperature: "Cold",
                dietaryInfo: "Vegetarian, Gluten-Free",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Balsamic Glaze"
            },
            paragraphs: [
                "Caprese Skewers are a refreshing and colorful appetizer featuring juicy cherry tomatoes, creamy mozzarella, and fragrant basil leaves, all drizzled with balsamic glaze.",
                "This simple yet elegant dish is a classic Italian starter that delivers flavor and freshness in every bite—ideal for parties and gatherings."
            ],
            ingredients: [
                "Cherry Tomatoes",
                "Fresh Mozzarella",
                "Fresh Basil Leaves",
                "Olive Oil",
                "Salt",
                "Black Pepper",
                "Balsamic Glaze",
                "Skewers"
            ],
            nutritions: [
                { label: "Calories", value: "160 kcal" },
                { label: "Protein", value: "7g" },
                { label: "Carbohydrates", value: "4g" },
                { label: "Fat", value: "12g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "220mg" },
                { label: "Cholesterol", value: "25mg" }
            ]
        },
        {
            id: 5,
            image: images.canapés5,
            title: "Beef Bite",
            content: "Tender beef cubes served with a tangy dipping sauce.",
            details: {
                price: "9",
                rating: "4.7/5 (based on 165 reviews)",
                portionSize: "120g",
                preparationTime: "12 mins",
                allergens: "Soy",
                servingTemperature: "Hot",
                dietaryInfo: "Non-Vegetarian, High-Protein",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Spicy Mustard Dip"
            },
            paragraphs: [
                "Enjoy our Beef Bites—juicy, tender pieces of marinated beef grilled to perfection and served with a flavorful dipping sauce for a bold taste.",
                "Perfect for meat lovers, this appetizer delivers a savory punch in a small, shareable form. Great for parties or as a protein-rich snack."
            ],
            ingredients: [
                "Beef Cubes",
                "Soy Sauce",
                "Garlic",
                "Ginger",
                "Black Pepper",
                "Brown Sugar",
                "Vegetable Oil",
                "Green Onions"
            ],
            nutritions: [
                { label: "Calories", value: "210 kcal" },
                { label: "Protein", value: "20g" },
                { label: "Carbohydrates", value: "5g" },
                { label: "Fat", value: "12g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "3g" },
                { label: "Sodium", value: "380mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        },
        {
            id: 6,
            image: images.canapés6,
            title: "Shrimp Cup",
            content: "Chilled shrimp with tangy sauce in a refreshing cup.",
            details: {
                price: "10",
                rating: "4.6/5 (based on 150 reviews)",
                portionSize: "100g",
                preparationTime: "8 mins",
                allergens: "Shellfish",
                servingTemperature: "Cold",
                dietaryInfo: "Pescatarian, Low-Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Events",
                recommendedPairing: "Lemon Wedges"
            },
            paragraphs: [
                "Our Shrimp Cup delivers a refreshing burst of flavor with tender shrimp, zesty cocktail sauce, and a hint of lemon. A light yet bold appetizer.",
                "Perfect for seafood lovers, this chilled treat is served in individual cups, combining convenience with an elegant presentation for events or casual bites."
            ],
            ingredients: [
                "Shrimp",
                "Cocktail Sauce",
                "Lemon Juice",
                "Fresh Dill",
                "Garlic Powder",
                "Black Pepper",
                "Celery",
                "Parsley"
            ],
            nutritions: [
                { label: "Calories", value: "120 kcal" },
                { label: "Protein", value: "15g" },
                { label: "Carbohydrates", value: "3g" },
                { label: "Fat", value: "5g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "320mg" },
                { label: "Cholesterol", value: "85mg" }
            ]
        },
        {
            id: 7,
            image: images.canapés7,
            title: "Fig Toast",
            content: "Toasted bread topped with fig spread and creamy cheese.",
            details: {
                price: "9",
                rating: "4.7/5 (based on 165 reviews)",
                portionSize: "120g",
                preparationTime: "7 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Warm",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Sparkling Wine"
            },
            paragraphs: [
                "Enjoy our Fig Toast—a delightful combination of toasted artisan bread, sweet fig preserve, and rich, creamy cheese. A perfect bite of sweet and savory.",
                "Balanced with a hint of herbs and a touch of honey drizzle, this starter is great for brunch tables, cocktail parties, or as a refined snack."
            ],
            ingredients: [
                "Fig Jam",
                "Goat Cheese",
                "Toasted Bread",
                "Honey",
                "Thyme",
                "Olive Oil",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "190 kcal" },
                { label: "Protein", value: "6g" },
                { label: "Carbohydrates", value: "22g" },
                { label: "Fat", value: "9g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "8g" },
                { label: "Sodium", value: "210mg" },
                { label: "Cholesterol", value: "20mg" }
            ]
        },
        {
            id: 8,
            image: images.canapés8,
            title: "Melon Wrap",
            content: "Juicy melon slices wrapped in delicate cured meat.",
            details: {
                price: "8",
                rating: "4.6/5 (based on 140 reviews)",
                portionSize: "100g",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Chilled",
                dietaryInfo: "Gluten-Free",
                spiceLevel: "None",
                availableFor: "Dine-In, Catering",
                recommendedPairing: "White Wine"
            },
            paragraphs: [
                "Melon Wrap is a refreshing appetizer combining the sweetness of ripe melon with the savory flavor of thinly sliced cured meat.",
                "Ideal for summer gatherings and elegant receptions, this dish is served chilled and brings a perfect balance of sweet and salty to your plate."
            ],
            ingredients: [
                "Cantaloupe Melon",
                "Prosciutto",
                "Mint Leaves",
                "Balsamic Glaze",
                "Olive Oil",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "120 kcal" },
                { label: "Protein", value: "7g" },
                { label: "Carbohydrates", value: "10g" },
                { label: "Fat", value: "6g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "8g" },
                { label: "Sodium", value: "330mg" },
                { label: "Cholesterol", value: "15mg" }
            ]
        }

    ],

    buffetFeastCategory: [
        {
            id: 1,
            image: images.buffet1,
            title: "Roasted Chicken",
            content: "Tender, herb-marinated chicken roasted to perfection with crispy skin and juicy meat.",
            details: {
                price: "18",
                rating: "4.9/5 (based on 384 reviews)",
                portionSize: "250g",
                preparationTime: "40 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "High Protein, Gluten-Free",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Chardonnay"
            },
            paragraphs: [
                "Our Roasted Chicken is a comfort classic—seasoned with aromatic herbs, garlic, and olive oil, then oven-roasted to a golden, crispy finish while keeping the meat juicy and flavorful.",
                "Ideal as a hearty main course, it's served with your choice of sides and pairs beautifully with a crisp white wine. A dish that's simple yet unforgettable, perfect for both everyday meals and special occasions."
            ],
            ingredients: [
                "Chicken (Bone-in, Skin-on)",
                "Garlic",
                "Olive Oil",
                "Rosemary",
                "Thyme",
                "Lemon Juice",
                "Salt",
                "Black Pepper",
                "Paprika"
            ],
            nutritions: [
                { label: "Calories", value: "410 kcal" },
                { label: "Protein", value: "35g" },
                { label: "Carbohydrates", value: "2g" },
                { label: "Fat", value: "28g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "0g" },
                { label: "Sodium", value: "360mg" },
                { label: "Cholesterol", value: "95mg" }
            ]
        },
        {
            id: 2,
            image: images.buffet2,
            title: "Garlic Shrimp",
            content: "Succulent shrimp sautéed in a fragrant garlic butter sauce with a touch of lemon and herbs.",
            details: {
                price: "16",
                rating: "4.8/5 (based on 320 reviews)",
                portionSize: "200g",
                preparationTime: "15 mins",
                allergens: "Shellfish, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Pescatarian, Low Carb",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Sauvignon Blanc"
            },
            paragraphs: [
                "Our Garlic Shrimp is a flavorful, quick-to-prepare dish that combines the sweetness of fresh shrimp with the richness of butter and garlic, enhanced by a touch of lemon and fresh herbs.",
                "Perfect as a light appetizer or paired with a fresh salad, this dish is sure to satisfy shrimp lovers with its delicious balance of flavors. Ideal for any occasion, from a casual dinner to a special gathering."
            ],
            ingredients: [
                "Shrimp (Peeled and Deveined)",
                "Garlic",
                "Butter",
                "Olive Oil",
                "Lemon Juice",
                "Parsley",
                "Red Pepper Flakes",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "190 kcal" },
                { label: "Protein", value: "24g" },
                { label: "Carbohydrates", value: "2g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "480mg" },
                { label: "Cholesterol", value: "170mg" }
            ]
        },
        {
            id: 3,
            image: images.buffet3,
            title: "Baked Ziti",
            content: "Cheesy baked ziti pasta with marinara sauce, perfectly seasoned ground beef, and a golden, melted mozzarella topping.",
            details: {
                price: "14",
                rating: "4.6/5 (based on 290 reviews)",
                portionSize: "350g",
                preparationTime: "30 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian Option Available",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Chianti"
            },
            paragraphs: [
                "Our Baked Ziti is a comforting, home-style Italian dish, featuring tender ziti pasta tossed in a rich marinara sauce and layered with seasoned ground beef, then baked to perfection with melted mozzarella cheese.",
                "A hearty meal that’s perfect for any occasion, this dish is sure to please both pasta lovers and meat enthusiasts. Enjoy it with a glass of red wine for a complete, satisfying experience."
            ],
            ingredients: [
                "Ziti Pasta",
                "Ground Beef",
                "Marinara Sauce",
                "Mozzarella Cheese",
                "Parmesan Cheese",
                "Garlic",
                "Olive Oil",
                "Onion",
                "Basil",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "450 kcal" },
                { label: "Protein", value: "20g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "20g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "780mg" },
                { label: "Cholesterol", value: "35mg" }
            ]
        },
        {
            id: 4,
            image: images.buffet4,
            title: "Veggie Medley",
            content: "A colorful mix of roasted seasonal vegetables, including bell peppers, zucchini, carrots, and sweet potatoes, seasoned with fresh herbs.",
            details: {
                price: "12",
                rating: "4.7/5 (based on 210 reviews)",
                portionSize: "250g",
                preparationTime: "20 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Vegan, Gluten-Free",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Pinot Grigio"
            },
            paragraphs: [
                "Our Veggie Medley is a vibrant, health-conscious dish that combines the earthy flavors of seasonal vegetables, gently roasted to enhance their natural sweetness and seasoned with fresh herbs.",
                "A perfect side dish to complement any meal or a light, satisfying main course for those seeking a nutritious and flavorful plant-based option. Pair it with a refreshing white wine for an added touch of elegance."
            ],
            ingredients: [
                "Bell Peppers",
                "Zucchini",
                "Carrots",
                "Sweet Potatoes",
                "Olive Oil",
                "Garlic",
                "Rosemary",
                "Thyme",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "180 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "38g" },
                { label: "Fat", value: "6g" },
                { label: "Fiber", value: "8g" },
                { label: "Sugars", value: "10g" },
                { label: "Sodium", value: "150mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 5,
            image: images.buffet5,
            title: "Mashed Potatoes",
            content: "Creamy mashed potatoes made with butter and cream, whipped to a silky smooth texture, and seasoned to perfection.",
            details: {
                price: "8",
                rating: "4.8/5 (based on 350 reviews)",
                portionSize: "250g",
                preparationTime: "20 mins",
                allergens: "Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Red Wine"
            },
            paragraphs: [
                "Our Mashed Potatoes are the ultimate comfort food—smooth, buttery, and rich, they’re made with a blend of cream and butter for a velvety texture that’s simply irresistible.",
                "Perfect as a side dish to any main course, these mashed potatoes elevate the flavor of any meal. Enjoy them with a hearty roast, or simply on their own for a warm and satisfying treat."
            ],
            ingredients: [
                "Potatoes",
                "Butter",
                "Heavy Cream",
                "Garlic",
                "Salt",
                "Black Pepper",
                "Chives"
            ],
            nutritions: [
                { label: "Calories", value: "220 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "35g" },
                { label: "Fat", value: "8g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "380mg" },
                { label: "Cholesterol", value: "25mg" }
            ]
        },
        {
            id: 6,
            image: images.buffet6,
            title: "Caesar Salad",
            content: "Crisp romaine lettuce tossed with creamy Caesar dressing, crunchy croutons, and grated parmesan cheese.",
            details: {
                price: "10",
                rating: "4.7/5 (based on 280 reviews)",
                portionSize: "250g",
                preparationTime: "10 mins",
                allergens: "Dairy, Gluten, Egg",
                servingTemperature: "Cold",
                dietaryInfo: "Vegetarian Option Available",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Chardonnay"
            },
            paragraphs: [
                "Our Caesar Salad is a fresh and classic favorite, with crisp romaine lettuce, rich Caesar dressing, crunchy croutons, and a generous sprinkle of parmesan cheese for that extra savory touch.",
                "Perfect as a light appetizer or a satisfying main dish, this salad offers a balance of creamy, crunchy, and tangy flavors, making it an ideal addition to any meal or event."
            ],
            ingredients: [
                "Romaine Lettuce",
                "Caesar Dressing",
                "Croutons",
                "Parmesan Cheese",
                "Garlic",
                "Lemon Juice",
                "Olive Oil",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "7g" },
                { label: "Carbohydrates", value: "15g" },
                { label: "Fat", value: "22g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "3g" },
                { label: "Sodium", value: "480mg" },
                { label: "Cholesterol", value: "30mg" }
            ]
        },
        {
            id: 7,
            image: images.buffet7,
            title: "Bread Rolls",
            content: "Soft, fluffy rolls freshly baked to a golden perfection, served warm with a pat of butter.",
            details: {
                price: "6",
                rating: "4.5/5 (based on 180 reviews)",
                portionSize: "150g",
                preparationTime: "25 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Soup, Salad, Main Course"
            },
            paragraphs: [
                "Our Bread Rolls are the ultimate comfort food—light, airy, and perfectly soft with a slightly crispy crust, making them the ideal accompaniment to any meal.",
                "Whether served alongside a hearty soup, salad, or main course, these freshly baked rolls are always a crowd-pleaser, best enjoyed warm with a pat of butter."
            ],
            ingredients: [
                "All-Purpose Flour",
                "Yeast",
                "Water",
                "Butter",
                "Sugar",
                "Salt",
                "Milk",
                "Egg"
            ],
            nutritions: [
                { label: "Calories", value: "150 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "30g" },
                { label: "Fat", value: "3g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "270mg" },
                { label: "Cholesterol", value: "20mg" }
            ]
        },
        {
            id: 8,
            image: images.buffet8,
            title: "Mousse Cup",
            content: "Velvety chocolate mousse served in a delicate cup, topped with whipped cream and chocolate shavings.",
            details: {
                price: "8",
                rating: "4.9/5 (based on 310 reviews)",
                portionSize: "150g",
                preparationTime: "15 mins",
                allergens: "Dairy, Egg",
                servingTemperature: "Cold",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Coffee or Espresso"
            },
            paragraphs: [
                "Indulge in our Mousse Cup—a smooth, creamy chocolate mousse topped with light whipped cream and decorated with rich chocolate shavings for a truly decadent dessert experience.",
                "Perfect for any occasion, this dessert offers a balance of sweetness and richness, providing a luxurious treat that’s sure to satisfy your chocolate cravings."
            ],
            ingredients: [
                "Dark Chocolate",
                "Heavy Cream",
                "Egg Yolks",
                "Sugar",
                "Vanilla Extract",
                "Whipped Cream",
                "Chocolate Shavings"
            ],
            nutritions: [
                { label: "Calories", value: "280 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "30g" },
                { label: "Fat", value: "18g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "22g" },
                { label: "Sodium", value: "70mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        }
    ],

    platedDinnerCategory: [
        {
            id: 1,
            image: images.plated1,
            title: "Sea Bass",
            content: "Deliciously tender sea bass fillets, pan-seared to perfection and served with a side of seasonal vegetables and a zesty lemon butter sauce.",
            details: {
                price: "18",
                rating: "4.8/5 (based on 400 reviews)",
                portionSize: "200g",
                preparationTime: "25 mins",
                allergens: "Fish, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Pescatarian",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Sauvignon Blanc"
            },
            paragraphs: [
                "Our Sea Bass is a light, yet flavorful dish—tender fillets seared to a crispy golden brown, served with seasonal vegetables and drizzled with a zesty lemon butter sauce for the perfect balance of freshness and richness.",
                "An elegant and delicious option for seafood lovers, this dish brings out the natural flavors of the fish and makes for a memorable dining experience."
            ],
            ingredients: [
                "Sea Bass Fillets",
                "Olive Oil",
                "Lemon Juice",
                "Butter",
                "Garlic",
                "Fresh Parsley",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "300 kcal" },
                { label: "Protein", value: "28g" },
                { label: "Carbohydrates", value: "5g" },
                { label: "Fat", value: "18g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "120mg" },
                { label: "Cholesterol", value: "60mg" }
            ]
        },
        {
            id: 2,
            image: images.plated2,
            title: "Filet Mignon",
            content: "A tender cut of beef, perfectly seared on the outside and juicy on the inside, served with a rich mushroom sauce and roasted vegetables.",
            details: {
                price: "28",
                rating: "4.9/5 (based on 500 reviews)",
                portionSize: "200g",
                preparationTime: "30 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "None",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Cabernet Sauvignon"
            },
            paragraphs: [
                "Our Filet Mignon is the epitome of fine dining—tender and juicy beef, perfectly seared to retain its natural flavors, and complemented by a savory mushroom sauce for an extra layer of richness.",
                "Ideal for steak lovers, this premium cut is a showstopper, offering a melt-in-your-mouth experience with every bite. Served with roasted vegetables, it's a complete meal that promises satisfaction."
            ],
            ingredients: [
                "Filet Mignon",
                "Olive Oil",
                "Butter",
                "Garlic",
                "Fresh Thyme",
                "Mushrooms",
                "Cream",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "400 kcal" },
                { label: "Protein", value: "45g" },
                { label: "Carbohydrates", value: "8g" },
                { label: "Fat", value: "22g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "2g" },
                { label: "Sodium", value: "350mg" },
                { label: "Cholesterol", value: "100mg" }
            ]
        },
        {
            id: 3,
            image: images.plated3,
            title: "Chicken Roulade",
            content: "A succulent chicken breast rolled with spinach, cheese, and herbs, then baked to perfection and served with a side of creamy mashed potatoes.",
            details: {
                price: "22",
                rating: "4.7/5 (based on 350 reviews)",
                portionSize: "180g",
                preparationTime: "35 mins",
                allergens: "Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Poultry",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Pinot Noir"
            },
            paragraphs: [
                "Our Chicken Roulade is a dish that combines flavor and elegance. Tender chicken breast, filled with a rich mixture of spinach, cheese, and fresh herbs, is carefully rolled and baked to golden perfection.",
                "This dish pairs wonderfully with creamy mashed potatoes, providing a balanced and satisfying meal that is both comforting and refined."
            ],
            ingredients: [
                "Chicken Breast",
                "Spinach",
                "Cream Cheese",
                "Mozzarella Cheese",
                "Garlic",
                "Fresh Herbs (Thyme, Rosemary)",
                "Olive Oil",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "38g" },
                { label: "Carbohydrates", value: "12g" },
                { label: "Fat", value: "18g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "3g" },
                { label: "Sodium", value: "480mg" },
                { label: "Cholesterol", value: "75mg" }
            ]
        },
        {
            id: 4,
            image: images.plated4,
            title: "Mushroom Risotto",
            content: "Creamy Arborio rice cooked with a blend of earthy mushrooms, fresh herbs, and Parmesan cheese, creating a rich and comforting dish.",
            details: {
                price: "16",
                rating: "4.6/5 (based on 320 reviews)",
                portionSize: "250g",
                preparationTime: "30 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Chardonnay"
            },
            paragraphs: [
                "Our Mushroom Risotto is a deliciously creamy dish made with high-quality Arborio rice, simmered in a rich broth and combined with earthy mushrooms, fresh herbs, and a touch of Parmesan cheese.",
                "This comforting dish offers a perfect balance of texture and flavor, ideal for a cozy dinner or as a side dish to complement a larger meal."
            ],
            ingredients: [
                "Arborio Rice",
                "Wild Mushrooms (Button, Cremini, Shiitake)",
                "Vegetable Broth",
                "Parmesan Cheese",
                "Garlic",
                "Shallots",
                "Olive Oil",
                "Butter",
                "Fresh Thyme",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "8g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "16g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "600mg" },
                { label: "Cholesterol", value: "20mg" }
            ]
        },
        {
            id: 5,
            image: images.plated5,
            title: "Glazed Carrots",
            content: "Tender carrots glazed with a sweet honey and butter sauce, garnished with fresh herbs for a flavorful, comforting side dish.",
            details: {
                price: "6",
                rating: "4.8/5 (based on 270 reviews)",
                portionSize: "150g",
                preparationTime: "20 mins",
                allergens: "Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Roast Chicken"
            },
            paragraphs: [
                "Our Glazed Carrots are the perfect balance of sweetness and savory flavors. Carrots are gently cooked until tender, then glazed with a honey-butter mixture for a smooth, sweet finish.",
                "A simple yet delicious side dish that enhances any meal, these glazed carrots are a great addition to both casual dinners and more formal gatherings."
            ],
            ingredients: [
                "Carrots",
                "Honey",
                "Butter",
                "Fresh Thyme",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "150 kcal" },
                { label: "Protein", value: "1g" },
                { label: "Carbohydrates", value: "35g" },
                { label: "Fat", value: "4g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "18g" },
                { label: "Sodium", value: "240mg" },
                { label: "Cholesterol", value: "15mg" }
            ]
        },
        {
            id: 6,
            image: images.plated6,
            title: "Green Salad",
            content: "A fresh and vibrant mix of seasonal greens, cucumber, tomatoes, and a light vinaigrette dressing, perfect for a refreshing start or a side dish.",
            details: {
                price: "8",
                rating: "4.5/5 (based on 280 reviews)",
                portionSize: "150g",
                preparationTime: "10 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Vegetarian, Vegan (with dressing adjustment)",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Grilled Fish"
            },
            paragraphs: [
                "Our Green Salad is a refreshing and healthy option, made with a variety of fresh greens, including lettuce, arugula, and spinach, along with crisp cucumber and ripe tomatoes.",
                "Topped with a simple vinaigrette dressing, this salad is light and full of flavor, making it the perfect complement to any main course or a healthy, stand-alone option."
            ],
            ingredients: [
                "Lettuce",
                "Arugula",
                "Spinach",
                "Cucumber",
                "Tomatoes",
                "Red Onion",
                "Olive Oil",
                "Balsamic Vinegar",
                "Lemon Juice",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "120 kcal" },
                { label: "Protein", value: "3g" },
                { label: "Carbohydrates", value: "10g" },
                { label: "Fat", value: "8g" },
                { label: "Fiber", value: "4g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "90mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 7,
            image: images.plated7,
            title: "Truffle Fries",
            content: "Crispy golden fries drizzled with luxurious truffle oil and sprinkled with Parmesan cheese and fresh herbs for an elevated twist on a classic side dish.",
            details: {
                price: "10",
                rating: "4.8/5 (based on 400 reviews)",
                portionSize: "180g",
                preparationTime: "15 mins",
                allergens: "Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Steak"
            },
            paragraphs: [
                "Our Truffle Fries are a gourmet take on a beloved classic. Crispy, golden fries are perfectly seasoned and then drizzled with aromatic truffle oil, giving them an irresistible, rich flavor.",
                "Topped with freshly grated Parmesan and herbs, these fries are an indulgent side dish that pairs wonderfully with steak, burgers, or as a standalone treat."
            ],
            ingredients: [
                "Russet Potatoes",
                "Truffle Oil",
                "Parmesan Cheese",
                "Fresh Parsley",
                "Garlic Powder",
                "Salt",
                "Black Pepper"
            ],
            nutritions: [
                { label: "Calories", value: "330 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "40g" },
                { label: "Fat", value: "18g" },
                { label: "Fiber", value: "5g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "500mg" },
                { label: "Cholesterol", value: "10mg" }
            ]
        },
        {
            id: 8,
            image: images.plated8,
            title: "Berry Tart",
            content: "A deliciously sweet and tangy tart filled with a rich custard and topped with fresh mixed berries, all nestled in a buttery, flaky crust.",
            details: {
                price: "7",
                rating: "4.9/5 (based on 180 reviews)",
                portionSize: "150g",
                preparationTime: "45 mins",
                allergens: "Dairy, Gluten",
                servingTemperature: "Cold",
                dietaryInfo: "Vegetarian",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Sweet Riesling"
            },
            paragraphs: [
                "Our Berry Tart is a delightful dessert that combines a smooth and creamy custard filling with the refreshing tartness of fresh berries. The delicate crust adds the perfect crunch to each bite.",
                "This sweet treat is ideal for any occasion, whether it's a family gathering, a special celebration, or simply a little indulgence to brighten your day."
            ],
            ingredients: [
                "Shortcrust Pastry",
                "Heavy Cream",
                "Eggs",
                "Sugar",
                "Vanilla Extract",
                "Mixed Berries (Strawberries, Blueberries, Raspberries)",
                "Lemon Zest",
                "Butter"
            ],
            nutritions: [
                { label: "Calories", value: "320 kcal" },
                { label: "Protein", value: "5g" },
                { label: "Carbohydrates", value: "45g" },
                { label: "Fat", value: "15g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "25g" },
                { label: "Sodium", value: "180mg" },
                { label: "Cholesterol", value: "80mg" }
            ]
        }
    ],

    bbqStationCategory: [
        {
            id: 1,
            image: images.BBQ1,
            title: "Beef Slider",
            content: "Miniature beef patties served in soft buns, topped with melted cheese, pickles, and a tangy sauce, perfect for a bite-sized indulgence.",
            details: {
                price: "9",
                rating: "4.7/5 (based on 350 reviews)",
                portionSize: "100g (per slider)",
                preparationTime: "15 mins",
                allergens: "Gluten, Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Contains Meat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Craft Beer"
            },
            paragraphs: [
                "Our Beef Slider is a mouthwatering mini burger, featuring a juicy beef patty grilled to perfection, served in a soft, toasted bun. It's topped with melted cheese, crispy pickles, and a tangy sauce for a balanced, savory bite.",
                "Perfect for parties, gatherings, or as a delicious snack, these sliders pack all the flavors of a full-sized burger in a fun, bite-sized portion."
            ],
            ingredients: [
                "Ground Beef",
                "Slider Buns",
                "Cheddar Cheese",
                "Pickles",
                "Lettuce",
                "Tomato",
                "Onions",
                "Ketchup",
                "Mustard",
                "Olive Oil"
            ],
            nutritions: [
                { label: "Calories", value: "250 kcal" },
                { label: "Protein", value: "14g" },
                { label: "Carbohydrates", value: "18g" },
                { label: "Fat", value: "14g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "400mg" },
                { label: "Cholesterol", value: "45mg" }
            ]
        },
        {
            id: 2,
            image: images.BBQ2,
            title: "Grilled Ribeye",
            content: "A tender and juicy ribeye steak, perfectly grilled to your desired level of doneness, seasoned with a special blend of spices for a mouthwatering flavor.",
            details: {
                price: "22",
                rating: "4.9/5 (based on 500 reviews)",
                portionSize: "250g",
                preparationTime: "25 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Contains Meat",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Red Wine (Cabernet Sauvignon)"
            },
            paragraphs: [
                "Our Grilled Ribeye is a steak lover's dream. With its marbled texture and rich, beefy flavor, it's grilled to perfection and seasoned with our secret spice blend to enhance its natural taste.",
                "Whether you're celebrating a special occasion or enjoying a hearty meal, this tender ribeye steak, served with your choice of sides, is sure to impress."
            ],
            ingredients: [
                "Ribeye Steak",
                "Olive Oil",
                "Garlic",
                "Rosemary",
                "Thyme",
                "Black Pepper",
                "Salt",
                "Butter"
            ],
            nutritions: [
                { label: "Calories", value: "650 kcal" },
                { label: "Protein", value: "50g" },
                { label: "Carbohydrates", value: "0g" },
                { label: "Fat", value: "50g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "0g" },
                { label: "Sodium", value: "150mg" },
                { label: "Cholesterol", value: "140mg" }
            ]
        },
        {
            id: 3,
            image: images.BBQ3,
            title: "Chicken Wings",
            content: "Crispy, tender chicken wings tossed in your choice of flavorful sauces, from tangy BBQ to spicy buffalo, making them the perfect finger food for any occasion.",
            details: {
                price: "12",
                rating: "4.8/5 (based on 320 reviews)",
                portionSize: "180g (6 pieces)",
                preparationTime: "20 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Contains Meat",
                spiceLevel: "Mild to Hot",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Cold Beer"
            },
            paragraphs: [
                "Our Chicken Wings are the perfect balance of crispy and tender. Cooked to perfection, they are tossed in a variety of delicious sauces that will satisfy every palate.",
                "Whether you prefer mild, tangy BBQ or fiery buffalo, these wings are ideal for snacking, sharing with friends, or as a tasty addition to your meal."
            ],
            ingredients: [
                "Chicken Wings",
                "Olive Oil",
                "Salt",
                "Black Pepper",
                "Garlic Powder",
                "Paprika",
                "BBQ Sauce (or Buffalo Sauce)",
                "Cayenne Pepper (for spicy sauce)",
                "Honey (for BBQ sauce)"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "25g" },
                { label: "Carbohydrates", value: "12g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "0g" },
                { label: "Sugars", value: "8g" },
                { label: "Sodium", value: "550mg" },
                { label: "Cholesterol", value: "75mg" }
            ]
        },
        {
            id: 4,
            image: images.BBQ4,
            title: "Beef Skewer",
            content: "Tender pieces of marinated beef grilled on skewers, served with a side of smoky dipping sauce and grilled vegetables for a savory, juicy bite.",
            details: {
                price: "14",
                rating: "4.8/5 (based on 280 reviews)",
                portionSize: "200g (2 skewers)",
                preparationTime: "20 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Contains Meat",
                spiceLevel: "Mild to Medium",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Red Wine (Merlot)"
            },
            paragraphs: [
                "Our Beef Skewer features tender cuts of beef, marinated in a flavorful blend of spices, skewered, and grilled to perfection. The smoky flavor from the grill and the juiciness of the beef make every bite mouthwatering.",
                "This dish is perfect for anyone craving a hearty, flavorful meal that’s ideal for sharing with friends and family. Paired with grilled vegetables and dipping sauce, it’s a crowd-pleasing choice for any gathering."
            ],
            ingredients: [
                "Beef (sirloin or tenderloin)",
                "Olive Oil",
                "Garlic",
                "Lemon Juice",
                "Rosemary",
                "Thyme",
                "Salt",
                "Black Pepper",
                "Paprika",
                "Bell Peppers (for skewering)",
                "Onions (for skewering)"
            ],
            nutritions: [
                { label: "Calories", value: "400 kcal" },
                { label: "Protein", value: "35g" },
                { label: "Carbohydrates", value: "10g" },
                { label: "Fat", value: "25g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "450mg" },
                { label: "Cholesterol", value: "85mg" }
            ]
        },
        {
            id: 5,
            image: images.BBQ5,
            title: "Corn Cob",
            content: "Grilled corn on the cob, brushed with a rich butter blend and seasoned with a touch of salt and pepper for a simple, yet flavorful side dish.",
            details: {
                price: "5",
                rating: "4.6/5 (based on 180 reviews)",
                portionSize: "1 cob",
                preparationTime: "10 mins",
                allergens: "Dairy",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Lemonade"
            },
            paragraphs: [
                "Our Corn Cob is a summer classic! Each cob is grilled to perfection, brushed with a creamy butter sauce, and seasoned with salt and pepper for a satisfying bite. Whether served as a side or a snack, it's the perfect addition to any meal.",
                "A true comfort food, this dish is simple yet full of flavor, making it ideal for all kinds of occasions, from family dinners to BBQ parties."
            ],
            ingredients: [
                "Corn on the Cob",
                "Butter",
                "Salt",
                "Black Pepper",
                "Paprika (optional)"
            ],
            nutritions: [
                { label: "Calories", value: "120 kcal" },
                { label: "Protein", value: "3g" },
                { label: "Carbohydrates", value: "27g" },
                { label: "Fat", value: "4g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "6g" },
                { label: "Sodium", value: "200mg" },
                { label: "Cholesterol", value: "15mg" }
            ]
        },
        {
            id: 6,
            image: images.BBQ6,
            title: "Spicy Sausage",
            content: "A flavorful, hearty sausage packed with spices, herbs, and a kick of heat, grilled to perfection and served with a side of tangy mustard or dipping sauce.",
            details: {
                price: "8",
                rating: "4.7/5 (based on 210 reviews)",
                portionSize: "180g (2 sausages)",
                preparationTime: "15 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Contains Meat",
                spiceLevel: "Spicy",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Cold Beer"
            },
            paragraphs: [
                "Our Spicy Sausage is a perfect blend of rich, savory flavors with just the right amount of heat. Grilled to perfection, each sausage is juicy on the inside and crisp on the outside, making for a deliciously satisfying bite.",
                "Ideal for those who enjoy bold flavors, this dish pairs beautifully with a refreshing drink or a side of crispy fries. Whether served as an appetizer or main course, it’s sure to please spice lovers."
            ],
            ingredients: [
                "Pork Sausage",
                "Paprika",
                "Chili Flakes",
                "Garlic",
                "Onions",
                "Cumin",
                "Salt",
                "Black Pepper",
                "Olive Oil"
            ],
            nutritions: [
                { label: "Calories", value: "350 kcal" },
                { label: "Protein", value: "25g" },
                { label: "Carbohydrates", value: "5g" },
                { label: "Fat", value: "28g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "1g" },
                { label: "Sodium", value: "600mg" },
                { label: "Cholesterol", value: "50mg" }
            ]
        },
        {
            id: 7,
            image: images.BBQ7,
            title: "Veggie Kabob",
            content: "Grilled skewers of vibrant, marinated vegetables, including bell peppers, zucchini, mushrooms, and onions, served with a side of tangy yogurt dip.",
            details: {
                price: "9",
                rating: "4.9/5 (based on 150 reviews)",
                portionSize: "200g (4 skewers)",
                preparationTime: "18 mins",
                allergens: "Dairy (if served with yogurt dip)",
                servingTemperature: "Hot",
                dietaryInfo: "Vegetarian, Vegan (if dip is omitted)",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Chilled White Wine"
            },
            paragraphs: [
                "Our Veggie Kabob is a colorful and healthy dish, perfect for vegetarians and anyone looking for a lighter yet flavorful meal. The vegetables are marinated in a blend of olive oil, garlic, and herbs, then grilled until perfectly tender with a delicious smoky flavor.",
                "These kabobs are great as an appetizer, a side dish, or as a light main course, and they’re best enjoyed with a side of tangy yogurt dip or your favorite sauce."
            ],
            ingredients: [
                "Bell Peppers",
                "Zucchini",
                "Mushrooms",
                "Onions",
                "Olive Oil",
                "Garlic",
                "Lemon Juice",
                "Salt",
                "Black Pepper",
                "Paprika",
                "Fresh Parsley",
                "Yogurt (for dip)"
            ],
            nutritions: [
                { label: "Calories", value: "180 kcal" },
                { label: "Protein", value: "4g" },
                { label: "Carbohydrates", value: "20g" },
                { label: "Fat", value: "10g" },
                { label: "Fiber", value: "6g" },
                { label: "Sugars", value: "5g" },
                { label: "Sodium", value: "300mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 8,
            image: images.BBQ8,
            title: "Grilled Pineapple",
            content: "Sweet pineapple slices grilled to perfection, caramelized on the outside, and bursting with tropical flavor. Served with a sprinkle of cinnamon and a drizzle of honey.",
            details: {
                price: "6",
                rating: "4.8/5 (based on 120 reviews)",
                portionSize: "2 slices",
                preparationTime: "10 mins",
                allergens: "None",
                servingTemperature: "Hot",
                dietaryInfo: "Vegan, Gluten-Free",
                spiceLevel: "Mild",
                availableFor: "Dine-In, Takeaway, Catering",
                recommendedPairing: "Coconut Water"
            },
            paragraphs: [
                "Our Grilled Pineapple is a sweet and tangy treat that's perfect for any occasion. Grilled until the sugars caramelize, the pineapple slices have a warm, smoky flavor that pairs beautifully with a dusting of cinnamon and a drizzle of honey.",
                "This dessert or side dish is a great way to enjoy a healthy, naturally sweet option while still indulging in the rich, tropical flavors of the pineapple."
            ],
            ingredients: [
                "Pineapple",
                "Cinnamon",
                "Honey",
                "Lime Juice (optional)"
            ],
            nutritions: [
                { label: "Calories", value: "150 kcal" },
                { label: "Protein", value: "1g" },
                { label: "Carbohydrates", value: "38g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "5g" },
                { label: "Sugars", value: "30g" },
                { label: "Sodium", value: "5mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        }
    ],

    signatureCocktailsCategory: [
        {
            id: 1,
            image: images.cocktail1,
            title: "Mint Mojito",
            content: "A refreshing cocktail made with muddled mint leaves, lime juice, rum, sugar, and soda water, served over ice for a cool, crisp finish.",
            details: {
                price: "7",
                rating: "4.9/5 (based on 350 reviews)",
                portionSize: "250ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Grilled Seafood"
            },
            paragraphs: [
                "Our Mint Mojito is the ultimate refreshing drink, perfect for a hot day or a casual gathering. The cool mint and zesty lime combine with rum and a touch of sweetness, making it a crowd favorite.",
                "This cocktail is light, flavorful, and energizing, providing a perfect balance of tangy and sweet flavors. It’s the ideal drink for those who enjoy a crisp, cooling beverage with a little kick."
            ],
            ingredients: [
                "Mint Leaves",
                "Lime Juice",
                "Rum",
                "Sugar",
                "Soda Water",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "150 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "20g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "18g" },
                { label: "Sodium", value: "10mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 2,
            image: images.cocktail2,
            title: "Mango Mule",
            content: "A tropical twist on the classic Moscow Mule, featuring fresh mango puree, vodka, lime juice, and ginger beer, served in a chilled copper mug.",
            details: {
                price: "8",
                rating: "4.8/5 (based on 280 reviews)",
                portionSize: "300ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "Mild (from ginger)",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Spicy Tacos"
            },
            paragraphs: [
                "Our Mango Mule brings a burst of tropical sweetness to the classic mule. The smooth mango puree complements the tangy lime and spicy ginger beer, creating a refreshing and exotic cocktail that’s perfect for any occasion.",
                "This drink is a delightful fusion of fruit and spice, offering a unique twist that’s sure to become a new favorite for anyone who loves a fresh, fruity cocktail with a little zing."
            ],
            ingredients: [
                "Mango Puree",
                "Vodka",
                "Lime Juice",
                "Ginger Beer",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "160 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "22g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "20g" },
                { label: "Sodium", value: "15mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 3,
            image: images.cocktail3,
            title: "Citrus Fizz",
            content: "A zesty and refreshing cocktail made with a mix of fresh citrus juices, vodka, and soda water, topped with a splash of club soda for a fizzy finish.",
            details: {
                price: "7",
                rating: "4.7/5 (based on 200 reviews)",
                portionSize: "250ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Grilled Shrimp"
            },
            paragraphs: [
                "Our Citrus Fizz is the perfect balance of sweet and tangy, with a refreshing burst of citrus flavors from oranges, lemons, and limes, complemented by the smooth kick of vodka. It’s the ultimate drink to beat the heat or to enjoy with friends.",
                "The sparkling soda finish adds a fizzy kick, making it light, bubbly, and highly refreshing. It’s an ideal choice for anyone who enjoys a crisp, fruity, and effervescent cocktail."
            ],
            ingredients: [
                "Orange Juice",
                "Lemon Juice",
                "Lime Juice",
                "Vodka",
                "Club Soda",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "140 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "20g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "18g" },
                { label: "Sodium", value: "5mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 4,
            image: images.cocktail4,
            title: "Apple Smash",
            content: "A crisp, fruity cocktail made with fresh apple juice, bourbon, a hint of cinnamon, and a touch of lemon, creating a perfect balance of sweet and tart flavors.",
            details: {
                price: "8",
                rating: "4.6/5 (based on 150 reviews)",
                portionSize: "300ml",
                preparationTime: "6 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "Mild (from cinnamon)",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Grilled Chicken"
            },
            paragraphs: [
                "The Apple Smash is a seasonal favorite, combining the natural sweetness of apple juice with the rich warmth of bourbon and a hint of cinnamon. It’s a drink that’s both cozy and refreshing, perfect for fall evenings or a casual get-together.",
                "With the tartness of lemon juice and a delicate cinnamon finish, this cocktail brings together the perfect blend of fruity, spicy, and sweet flavors, making it a standout choice for any occasion."
            ],
            ingredients: [
                "Apple Juice",
                "Bourbon",
                "Lemon Juice",
                "Cinnamon",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "180 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "25g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "2g" },
                { label: "Sugars", value: "22g" },
                { label: "Sodium", value: "10mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 5,
            image: images.cocktail5,
            title: "Passion Punch",
            content: "A vibrant and exotic cocktail featuring a blend of passion fruit juice, rum, lime, and orange liqueur, topped with soda water for a refreshing, tropical experience.",
            details: {
                price: "9",
                rating: "4.8/5 (based on 320 reviews)",
                portionSize: "350ml",
                preparationTime: "7 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Grilled Fish Tacos"
            },
            paragraphs: [
                "The Passion Punch is an irresistible tropical cocktail that blends the sweet and tangy flavors of passion fruit with rum, citrus, and a dash of orange liqueur. It’s a fun, refreshing drink that brings the spirit of summer to any gathering.",
                "Perfect for those who love vibrant, fruit-forward cocktails, this punch delivers a burst of tropical flavors in every sip, making it ideal for pool parties, beach events, or simply enjoying a refreshing drink with friends."
            ],
            ingredients: [
                "Passion Fruit Juice",
                "Rum",
                "Lime Juice",
                "Orange Liqueur",
                "Soda Water",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "190 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "28g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "3g" },
                { label: "Sugars", value: "25g" },
                { label: "Sodium", value: "15mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 6,
            image: images.cocktail6,
            title: "Mint Cooler",
            content: "A refreshing, mint-infused cocktail made with muddled mint leaves, lime juice, rum, and soda water, served over ice for a cool and revitalizing drink.",
            details: {
                price: "7",
                rating: "4.9/5 (based on 250 reviews)",
                portionSize: "300ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Lemonade Shrimp Skewers"
            },
            paragraphs: [
                "The Mint Cooler is the ultimate refreshing cocktail, perfect for warm days. The combination of fresh mint, lime, and rum creates a light, crisp drink with just the right amount of zing. It’s the perfect balance of minty coolness and citrusy freshness.",
                "This drink is easy to love with its vibrant, herbal flavors, making it a go-to choice for casual gatherings, picnics, or any time you need a revitalizing cocktail to beat the heat."
            ],
            ingredients: [
                "Mint Leaves",
                "Lime Juice",
                "Rum",
                "Soda Water",
                "Ice"
            ],
            nutritions: [
                { label: "Calories", value: "120 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "15g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "12g" },
                { label: "Sodium", value: "10mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 7,
            image: images.cocktail7,
            title: "Rosé Spritz",
            content: "A light and sparkling cocktail made with rosé wine, a splash of soda water, and a hint of orange liqueur, offering a crisp and refreshing taste with a hint of fruitiness.",
            details: {
                price: "9",
                rating: "4.7/5 (based on 300 reviews)",
                portionSize: "250ml",
                preparationTime: "5 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Bruschetta"
            },
            paragraphs: [
                "The Rosé Spritz is the perfect combination of crisp rosé wine and sparkling soda, making it the ultimate refreshing drink for summer. A touch of orange liqueur adds a burst of citrus, while the bubbles provide a fizzy, light finish.",
                "Perfect for any occasion, the Rosé Spritz is an elegant and easy-drinking cocktail, ideal for sunny afternoons or casual evening gatherings."
            ],
            ingredients: [
                "Rosé Wine",
                "Orange Liqueur",
                "Soda Water",
                "Ice",
                "Orange Slice (for garnish)"
            ],
            nutritions: [
                { label: "Calories", value: "130 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "16g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "14g" },
                { label: "Sodium", value: "15mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        },
        {
            id: 8,
            image: images.cocktail8,
            title: "Citrus Bloom",
            content: "A vibrant and aromatic cocktail with a combination of fresh citrus juices, gin, elderflower liqueur, and a splash of soda water, offering a floral and tangy flavor profile.",
            details: {
                price: "10",
                rating: "4.8/5 (based on 180 reviews)",
                portionSize: "300ml",
                preparationTime: "7 mins",
                allergens: "None",
                servingTemperature: "Cold",
                dietaryInfo: "Contains Alcohol",
                spiceLevel: "None",
                availableFor: "Dine-In, Takeaway",
                recommendedPairing: "Goat Cheese Salad"
            },
            paragraphs: [
                "The Citrus Bloom is a refreshing, bright cocktail that combines the floral notes of elderflower liqueur with the zesty freshness of citrus juices. Perfect for spring and summer, this cocktail is both uplifting and easy to sip.",
                "With the light, crisp taste of gin and a splash of soda water, this drink brings a harmonious balance of tangy, floral, and slightly sweet flavors, making it a perfect choice for any celebration or garden party."
            ],
            ingredients: [
                "Gin",
                "Elderflower Liqueur",
                "Lemon Juice",
                "Orange Juice",
                "Soda Water",
                "Ice",
                "Lemon Peel (for garnish)"
            ],
            nutritions: [
                { label: "Calories", value: "140 kcal" },
                { label: "Protein", value: "0g" },
                { label: "Carbohydrates", value: "18g" },
                { label: "Fat", value: "0g" },
                { label: "Fiber", value: "1g" },
                { label: "Sugars", value: "15g" },
                { label: "Sodium", value: "20mg" },
                { label: "Cholesterol", value: "0mg" }
            ]
        }
    ],

};

export default eventMenu;